<h2 class="h3">{{ 'product.product_filters.heading' | translate }}</h2>

<div *ngIf="filterNavigation" class="row justify-content-left">
  <div *ngFor="let element of filterNavigation.filter; trackBy: trackByFn" class="filter-dropdown col-sm-6 col-md-3">
    <ish-filter-dropdown [filterElement]="element" (applyFilter)="applyFilter.emit($event)" />
  </div>
</div>
